/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Intro_EyebrowInputs */

const es_gift_intro_eyebrow = /** @type {(inputs: Gift_Intro_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejor que calcetines`)
};

const gl_gift_intro_eyebrow = /** @type {(inputs: Gift_Intro_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mellor que calcetíns`)
};

const en_gift_intro_eyebrow = /** @type {(inputs: Gift_Intro_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Better than socks`)
};

/**
* | output |
* | --- |
* | "Better than socks" |
*
* @param {Gift_Intro_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_intro_eyebrow = /** @type {((inputs?: Gift_Intro_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Intro_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_intro_eyebrow(inputs)
	if (locale === "en") return en_gift_intro_eyebrow(inputs)
	return es_gift_intro_eyebrow(inputs)
});